module.exports = __webpack_public_path__ + "img/violet_059.0da0c5d4.png";